module.exports = __webpack_public_path__ + "static/media/ricardo-perez-star.d6ff4bf9.svg";